import "dayjs/locale/ja";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ja from "dayjs/locale/ja";
dayjs.extend(utc);
dayjs.locale(ja);

export default dayjs;

export const formatUTCDateString = (date: string) => {
  return dayjs.utc(date).format("YYYY/MM/DD HH:mm:ss");
};

export const formatDateString = (date: string): string => {
  return dayjs(Date.parse(date)).format("YYYY/MM/DD HH:mm:ss");
};

export const formatDate = (date: Date): string => {
  return dayjs(date).format("YYYY-MM-DD");
};

export const formatDatetime = (date: Parameters<typeof dayjs>[0]): string => {
  return dayjs(date).format("YYYY/MM/DD HH:mm");
};

export const formatToSimpleTimestamp = (
  date: Parameters<typeof dayjs>[0],
): string => {
  return dayjs(date).format("YYYYMMDDHHmm");
};

export const formatDatetimeForInput = (date: Date): string => {
  return dayjs(date).format("YYYY-MM-DDTHH:mm");
};

export const formatOnlyDate = (date: Parameters<typeof dayjs>[0]): string => {
  return dayjs(date, "YYYYMMDD").format("YYYY/MM/DD");
};

export const parseDate = (d: string): Date => {
  return dayjs(d).toDate();
};

export const unixSecToTimeString = (unixSec: number): string => {
  const date = new Date(unixSec * 1000);
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date
    .getHours()
    .toString()
    .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
};

export const formatDateRange = (start: Date, end: Date | null) => {
  if (!end) return formatDate(start);

  const startDate = formatDate(start);
  const endDate = formatDate(end);
  return startDate === endDate ? startDate : `${startDate} 〜 ${endDate}`;
};
